import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-hot-toast';
import { getDashboardUrl } from '../../api/MetabaseApi';

export function FreeOffersDashboard() {
  const influencerId = useInfluencerId();
  const [isLoading, setIsLoading] = useState(false);
  const [fullScreen, setFullscreen] = useState(false);
  const [freeOtpUrl, setFreeOtpUrl] = useState('');

  useKeyPress('Escape', function onEscPress() {
    setFullscreen((x) => !x);
    return null;
  });

  useEffect(() => {
    setIsLoading(true);
    getDashboardUrl('FreeOTP', {
      influencerId: influencerId.toString(),
    })
      .then(({ url }) => {
        setFreeOtpUrl(url || '');
      })
      .catch(() => toast.error('Could not load Free Offers Dashboard'))
      .finally(() => {
        setIsLoading(false);
      });
  }, [influencerId]);

  return (
    <div>
      <div className="mb-2"></div>
      {isLoading ? null : (
        <div>
          <iframe
            src={freeOtpUrl}
            width="100%"
            style={
              fullScreen
                ? {
                    width: 'calc(100vw - 100px)',
                    height: '100vh',
                    position: 'fixed',
                    left: 100,
                    top: 0,
                  }
                : { height: 'calc(100vh - 200px)' }
            }
          />
        </div>
      )}
    </div>
  );
}

const useKeyPress = (targetKey, onPress = () => null) => {
  const [keyPressed, setKeyPressed] = useState(false);

  const downHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(true);
      onPress();
    }
  };

  const upHandler = ({ key }) => {
    if (key === targetKey) setKeyPressed(false);
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return keyPressed;
};
